module.exports = __webpack_public_path__ + "videos/majesty_lg.4783ece.mp4";